// lenis scroll loaded
const scrollSet = (() => {

    const body = document.body;
    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    // Reduced motion: skip Lenis smooth-scroll interpolation entirely and fall
    // back to native scrolling, while keeping the public API so drawer/popup
    // body-scroll-lock still works (WCAG 2.3.3).
    if (prefersReducedMotion) {
        return {
            lenisResize: () => {},
            lenisStop: () => {
                body.style.cssText = 'overflow: hidden;';
            },
            lenisStart: () => {
                body.style.cssText = '';
            },
            otherLenisScroll: () => {},
            lenisScrollTo: (position) => {
                window.scrollTo({ top: position });
            }
        };
    }

    const lenis = new Lenis({
        duration: 1.2,
        easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
        gestureTarget: (target) => {
            return target === body || target.closest('body');
        },
    });

    let lastHeight = document.body.scrollHeight;

    const checkHeightChange = () => {
        const currentHeight = document.body.scrollHeight;
        if (currentHeight !== lastHeight) {
            lastHeight = currentHeight;
            lenis.resize();
        }
    };

    const onScroll = () => {
        requestAnimationFrame(checkHeightChange);
    };

    lenis.on('scroll', onScroll);

    function raf(time) {
        lenis.raf(time);
        requestAnimationFrame(raf);
    }
    requestAnimationFrame(raf);

    const lenisResize = () => {
        lenis.resize();
    }

    const lenisStop = () => {
        lenis.stop();
        body.style.cssText = 'overflow: hidden;'
    };

    const lenisStart = () => {
        lenis.start();
        body.style.cssText = '';
    };

    // 내부스크롤 사용 시 lenis블락
    const activeBlockScroll = new Map();

    const otherLenisScroll = (target, boolean) => {
        const setTarget = document.querySelector(target);

        if (!setTarget) {
            console.error(`Target element "${target}" not found.`);
            return;
        }

        const onWheel = (e) => {
            e.stopPropagation(); // Lenis 이벤트 전파 차단
        };

        const onTouchMove = (e) => {
            e.stopPropagation(); // TouchMove 이벤트 전파 차단
        };

        if (boolean) {
            if (!activeBlockScroll.has(target)) {
                setTarget.addEventListener('wheel', onWheel);
                setTarget.addEventListener('touchmove', onTouchMove);
                activeBlockScroll.set(target, { onWheel, onTouchMove }); // 저장
            }
        } else {
            if (activeBlockScroll.has(target)) {
                const { onWheel, onTouchMove } = activeBlockScroll.get(target);
                setTarget.removeEventListener('wheel', onWheel);
                setTarget.removeEventListener('touchmove', onTouchMove);
                activeBlockScroll.delete(target); // 제거
            }
        }
    }

    const lenisScrollTo = (position, duration = 1) => {
        lenis.scrollTo(body, {
            offset: position,
            lock: true,
            duration: duration
        });
    }

    // image lazyloading 관련처리
    // const lazyImages = document.querySelectorAll('img[loading="lazy"]'); // lazy load 대상 이미지 선택

    // const onIntersection = (entries, observer) => {
    //     entries.forEach(entry => {
    //         if (entry.isIntersecting) {
    //             const img = entry.target;
    //             observer.unobserve(img); // 관찰 중지
    //             lenisResize();
    //         }
    //     });
    // };
    
    // const observer = new IntersectionObserver(onIntersection, {
    //     threshold: 0
    // });
    
    // lazyImages.forEach(img => observer.observe(img));

    // document.querySelector('.go-to-top').addEventListener('click', () => {
    //     lenis.scrollTo(body, {
    //         offset: 0,
    //         lock: true
    //     });
    // });

    return {
        lenisResize: () => {
            lenisResize();
        },
        lenisStop: () => {
            lenisStop();
        },
        lenisStart: () => {
            lenisStart();
        },
        otherLenisScroll: (target, boolean) => {
            otherLenisScroll(target, boolean);
        },
        lenisScrollTo: (position) => {
            lenisScrollTo(position);
        }
    };

})();

class setParallax {
    constructor(parent, target, start, end, startP, endP, duration) {
        this.parent = parent; // parent class
        this.target = target; // target class
        this.start = start || '-15%'; // start position
        this.end = end || '15%'; // end position
        this.startP = startP || 'top bottom',
        this.endP = endP || 'bottom top'
        this.duration = duration || 5; // duration

        this.init();
    }

    init() {
        // Reduced motion: no scroll-driven parallax (WCAG 2.3.3).
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        gsap.registerPlugin(ScrollTrigger);
        gsap.fromTo(this.target,
            { 
                y: this.start
            },
            {
            y: this.end,
            duration: this.duration,
            ease: 'none',
            scrollTrigger: {
                trigger: this.parent,
                start: this.startP,
                end: this.endP,
                scrub: true,
                // markers: true
            }
        });
    }
}


